// DS: CR16
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ListMenu from '../../../Dropdown/Preset/ListMenu';
import classnames from 'classnames';
import SubmitButton from './SubmitButton';
import SubmitMenuItem from './SubmitMenuItem';
import { desktopSubmitMenuItems } from '../../constants';
import TierCreatorReduxModule from '../../../Tier/redux/creator/ModuleLoadable';
import s from './SubmitMenu.scss';
var SubmitMenu = function (_a) {
    var className = _a.className, menuClassName = _a.menuClassName, isOpen = _a.isOpen, isLegacyHeader = _a.isLegacyHeader, toggleSubmitMenu = _a.toggleSubmitMenu;
    var t = useTranslation().t;
    var submitMenuItems = useMemo(function () {
        return desktopSubmitMenuItems.map(function (_a) {
            var type = _a.type, label = _a.label, target = _a.target, _b = _a.verificationAction, verificationAction = _b === void 0 ? 'submit' : _b, link = _a.link, modalType = _a.modalType, modalOptions = _a.modalOptions, isNew = _a.isNew, showDaProtect = _a.showDaProtect;
            return {
                key: label,
                renderElement: function () { return (React.createElement(SubmitMenuItem, { className: s['submit-menu-item'], hoverComponentClassName: s['hover-component'], type: type, modalType: modalType, modalOptions: modalOptions, label: label, link: link, target: target, verificationAction: verificationAction, showDaProtect: showDaProtect, isNew: isNew, isLegacyHeader: isLegacyHeader })); },
            };
        });
    }, [isLegacyHeader]);
    return (React.createElement(React.Fragment, null,
        isOpen && React.createElement(TierCreatorReduxModule, null),
        React.createElement("div", { className: classnames(s['submit-dropdown'], className) },
            React.createElement("div", { className: s['submit-button-link-wrapper'] },
                React.createElement(SubmitButton, { className: classnames(s['submit-button'], isOpen && s['submit-button-open']), isOpen: isOpen, onClick: toggleSubmitMenu, id: "site-header-submit-button", "aria-controls": "site-header-submit-menu" }, t('siteHeader.submit'))),
            React.createElement("div", { role: "menu", id: "site-header-submit-menu", "aria-labelledby": "site-header-submit-button", className: s['submit-menu-wrapper'], "aria-hidden": !isOpen },
                React.createElement(ListMenu, { className: classnames(menuClassName, s['submit-menu']), items: submitMenuItems })))));
};
SubmitMenu.displayName = 'SubmitMenu';
export default SubmitMenu;
//# sourceMappingURL=SubmitMenu.js.map